import { IconButton } from 'shared/components/ui/icon-button';
import styled from 'styled-components';

export const Button = styled(IconButton)`
  cursor: default;

  color: ${({ theme }) => theme.palette.text.secondary};

  &:active {
    cursor: grabbing;
  }
`;
